module.exports = __webpack_public_path__ + "static/img/inner_box_label_2.299e8a9d.png";